import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

// Types
import { MappingFilter, MappingFilterInput } from "@/Common/types/meta/mappingFilters";

export async function getFlags(locationId: string): Promise<Flag[] | null> {
	const query = gql`
		query getFlags($locationId: String!) {
			getFlags(locationId: $locationId) {
				_id
				name
				icon
				abbr
				code
				mask
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getFlags;
	} catch (err) {
		errorLogger(err as Error, { function: "getFlags", message: "Error getting flags", variables });
		return null;
	}
}

export async function getProgramDetails(variables: OEMProgramDetailsInput): Promise<OEMProgramDetails | null> {
	const query = gql`
		query getProgramDetails($oemReference: String!, $program: String!, $filter: OEMProgramFilterInput) {
			getProgramDetails(oemReference: $oemReference, program: $program, filter: $filter) {
				program
				version
				department
				oemReference
				details {
					department
					departmentKey
					oemMetrics
					metrics {
						levelsDisabled
						metricKey
						metricName
						tooltip
					}
					levels {
						level
						levelKey
						levelWeight
					}
					individualReferences {
						reference
						referenceName
					}
					storeReferences {
						reference
						referenceName
					}
				}
			}
		}
	`;

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getProgramDetails ?? null;
	} catch (err) {
		errorLogger(err as Error, { function: "getProgramDetails", message: "Error getting the program details", variables });
		return null;
	}
}

export async function getMappingFilters(variables: MappingFilterInput): Promise<MappingFilter[] | null> {
	const query = gql`
		query getMappingFilters($provider: String, $category: String, $options: MappingFilterInput) {
			getMappingFilters(provider: $provider, category: $category, options: $options) {
				name
				category
				provider
				columns {
					order
					isPinned
					headerKey
					headerName
					headerAlignment
					resizable
					filterable
					sortable
					align
					columnType
					variant
					width
					flex
					separator
					footer {
						label
					}
					dateParams {
						format
						isUTC
					}
					pathToValues {
						property
						pathToValue
						alternativeText
						dialogTitle
					}
				}
			}
		}
	`;

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getMappingFilters;
	} catch (err) {
		errorLogger(err as Error, { function: "getMappingFilters", message: "Error getting mapping filters", variables });
		return null;
	}
}
